import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryIndexPosters(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters/${indexPosterId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  subTitle
 * @param  type
 * @param  coverPath
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addIndexPoster(
  {
    title,
    subTitle,
    type,
    coverPath,
    videoPath,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters`,
    method: 'post',
    data: {
      title,
      subTitle,
      type,
      coverPath,
      videoPath,
    },
  });
}

/**
 * 更新
 * @param indexPosterId
 * @param  title
 * @param  subTitle
 * @param  type
 * @param  coverPath
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateIndexPoster(indexPosterId, {
  title,
  subTitle,
  type,
  coverPath,
  videoPath,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters/${indexPosterId}`,
    method: 'patch',
    data: {
      title,
      subTitle,
      type,
      coverPath,
      videoPath,
    },
  });
}

/**
 * 更新
 * @param indexPosterId
 * @param  title
 * @param  subTitle
 * @param  type
 * @param  coverPath
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateIndexPosterJumpTarget(indexPosterId, {
  jumpType,
  targetId,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters/${indexPosterId}/jump-target`,
    method: 'patch',
    data: {
      jumpType,
      targetId,
    },
  });
}

/**
 * 删除
 * @param indexPosterId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters/${indexPosterId}`,
    method: 'delete',
  });
}

/**
 * 删除
 * @param indexPosterId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters/${indexPosterId}/up`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param indexPosterId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-posters/${indexPosterId}/down`,
    method: 'patch',
  });
}
